import React from 'react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Linkedin, 
  Twitter, 
  ArrowRight,
  Building2
} from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    solutions: [
      { name: 'Project Management', href: '#services' },
      { name: 'Supply Chain', href: '#services' },
      { name: 'Chemistry & Formulations', href: '#services' },
      { name: 'Analytical Services', href: '#services' },
      { name: 'Finance & Accounting', href: '#services' }
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Features', href: '#features' },
      { name: 'Contact', href: '#contact' },
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' }
    ],
    industries: [
      { name: 'Pharmaceutical', href: '#' },
      { name: 'Chemical Manufacturing', href: '#' },
      { name: 'Analytical Labs', href: '#' },
      { name: 'Chemistry Services', href: '#' }
    ]
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6">
              <Building2 className="h-8 w-8 text-teal-400 mr-3" />
              <div className="text-2xl font-bold text-white">GENRA TECH</div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              U.S.-registered software consulting organization delivering customizable, 
              high-scale ERP solutions for pharmaceutical and chemical industries.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center text-gray-400">
                <Mail className="h-5 w-5 mr-3 text-teal-400" />
                <span>info@genratech.com</span>
              </div>
              <div className="flex items-center text-gray-400">
                <Phone className="h-5 w-5 mr-3 text-teal-400" />
                <span>+1 (732) 595-857</span>
              </div>
              <div className="flex items-center text-gray-400">
                <MapPin className="h-5 w-5 mr-3 text-teal-400" />
                <span>United States</span>
              </div>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries & Newsletter */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Industries</h4>
            <ul className="space-y-3 mb-8">
              {footerLinks.industries.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <div className="bg-gray-800 rounded-lg p-4">
              <h5 className="font-semibold text-white mb-2">Ready to Get Started?</h5>
              <p className="text-gray-400 text-sm mb-4">Schedule a demo today</p>
              <Button 
                size="sm" 
                className="bg-teal-600 hover:bg-teal-700 text-white group w-full"
              >
                Request Demo
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Separator className="bg-gray-800" />

      {/* Bottom Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Genra Tech. All rights reserved.
          </div>
          
          {/* Social Links & Additional Info */}
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-4">
              <a 
                href="#" 
                className="text-gray-400 hover:text-teal-400 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="text-gray-400 hover:text-teal-400 transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
            
            <Separator orientation="vertical" className="h-4 bg-gray-700" />
            
            <div className="text-gray-400 text-sm">
              21 CFR Part 11 Compliant
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};